import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import NonAppPageShell from "./NonAppPageShell";
export default function TermsPage(t0) {
  const $ = _c(30);
  const {
    appName: t1,
    agencyName: t2,
    contactEmail: t3,
    origin: t4
  } = t0;
  const appName = t1 === undefined ? "Catchy" : t1;
  const agencyName = t2 === undefined ? "the public transport agency" : t2;
  const contactEmail = t3 === undefined ? "feedback@catchy.nz" : t3;
  const origin = t4 === undefined ? "https://catchy.nz" : t4;
  const t5 = `${origin}/terms`;
  const t6 = `${origin}/share/default-share-image.png`;
  let t7;
  let t8;
  let t9;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <h1 className="mb-4 text-3xl font-semibold">Terms of use</h1>;
    t8 = <p className="mb-6">Catchy is a free, independent public transport app. It is built to be useful, fast, and accurate, but it is provided as-is. By using Catchy, you agree to use your own judgement and to check official information when it really matters.</p>;
    t9 = <h2 className="mb-2 text-xl font-semibold">Not official advice</h2>;
    $[0] = t7;
    $[1] = t8;
    $[2] = t9;
  } else {
    t7 = $[0];
    t8 = $[1];
    t9 = $[2];
  }
  let t10;
  if ($[3] !== agencyName) {
    t10 = <p className="mb-4">Catchy is not an official app from {agencyName}. Public transport data comes from third-party feeds and may be late, missing, duplicated, incorrect, or temporarily unavailable.</p>;
    $[3] = agencyName;
    $[4] = t10;
  } else {
    t10 = $[4];
  }
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t20;
  let t21;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <p className="mb-6">Do not rely on Catchy as your only source for important journeys, connections, work commitments, school pickups, medical appointments, or anything safety-critical.</p>;
    t12 = <h2 className="mb-2 text-xl font-semibold">No warranty</h2>;
    t13 = <p className="mb-6">Catchy is provided without warranties of any kind. I do not guarantee that the app, website, maps, predictions, alerts, APIs, or stored preferences will always be available, correct, secure, or suitable for a particular purpose.</p>;
    t14 = <h2 className="mb-2 text-xl font-semibold">No liability</h2>;
    t15 = <p className="mb-6">To the extent allowed by law, I am not responsible for losses, costs, missed trips, delays, wrong directions, data loss, device issues, or other problems that come from using Catchy or relying on information in Catchy.</p>;
    t16 = <h2 className="mb-2 text-xl font-semibold">Use the app, not the pipes</h2>;
    t17 = <p className="mb-4">Catchy has endpoints that exist to make the app work. Please do not use them as your own API, scrape them, bulk download from them, automate against them, or build another service on top of them without permission.</p>;
    t18 = <p className="mb-6">If you need public transport data, use the official feeds where available. If you want to do something with Catchy data specifically, ask first.</p>;
    t19 = <h2 className="mb-2 text-xl font-semibold">Be reasonable</h2>;
    t20 = <p className="mb-6">Do not try to break, overload, reverse engineer, bypass limits, interfere with, or abuse Catchy. Do not use Catchy in a way that harms the app, other users, data providers, or infrastructure providers.</p>;
    t21 = <h2 className="mb-2 text-xl font-semibold">Third-party services</h2>;
    $[5] = t11;
    $[6] = t12;
    $[7] = t13;
    $[8] = t14;
    $[9] = t15;
    $[10] = t16;
    $[11] = t17;
    $[12] = t18;
    $[13] = t19;
    $[14] = t20;
    $[15] = t21;
  } else {
    t11 = $[5];
    t12 = $[6];
    t13 = $[7];
    t14 = $[8];
    t15 = $[9];
    t16 = $[10];
    t17 = $[11];
    t18 = $[12];
    t19 = $[13];
    t20 = $[14];
    t21 = $[15];
  }
  let t22;
  let t23;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <p className="mb-6">Catchy depends on services for hosting, maps, weather, transport data, app stores, and optional region-specific features. Those services may have their own terms and privacy practices. The current service list is maintained on the{" "}<Link href="/about" className="text-blue-500">About page</Link>.</p>;
    t23 = <h2 className="mb-2 text-xl font-semibold">Changes</h2>;
    $[16] = t22;
    $[17] = t23;
  } else {
    t22 = $[16];
    t23 = $[17];
  }
  let t24;
  if ($[18] !== appName) {
    t24 = <p className="mb-6">These terms may change as Catchy changes. If you keep using {appName}, the latest version applies.</p>;
    $[18] = appName;
    $[19] = t24;
  } else {
    t24 = $[19];
  }
  let t25;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <h2 className="mb-2 text-xl font-semibold">Questions</h2>;
    $[20] = t25;
  } else {
    t25 = $[20];
  }
  const t26 = `mailto:${contactEmail}`;
  let t27;
  if ($[21] !== contactEmail || $[22] !== t26) {
    t27 = <p className="mb-6">If you have questions, or if you want permission to use Catchy data or endpoints for something, contact{" "}<a href={t26} className="text-blue-500">{contactEmail}</a>.</p>;
    $[21] = contactEmail;
    $[22] = t26;
    $[23] = t27;
  } else {
    t27 = $[23];
  }
  let t28;
  if ($[24] !== t10 || $[25] !== t24 || $[26] !== t27 || $[27] !== t5 || $[28] !== t6) {
    t28 = <NonAppPageShell title={"Catchy \u2014 Terms of use"} description="Plain-language terms for using Catchy." canonicalUrl={t5} image={t6} className="pb-10">{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}{t18}{t19}{t20}{t21}{t22}{t23}{t24}{t25}{t27}</NonAppPageShell>;
    $[24] = t10;
    $[25] = t24;
    $[26] = t27;
    $[27] = t5;
    $[28] = t6;
    $[29] = t28;
  } else {
    t28 = $[29];
  }
  return t28;
}